import React, { useContext } from 'react';
import { Box, Paper, Typography, useTheme } from '@mui/material';
import { UiContext } from 'uiContext';
import { DEFAULT_ELEVATION } from 'assets/theme';
import IconCODD from 'icons/iconCODD';
import SpeedContainer from 'components/speedStat/components/speedContainer';
import { getScoreThemeColor } from 'helpers/utils';
import { SpeedStatProps } from 'components/speedStat/speedStatDesktop';

export default function SpeedStatMobileExtended({
  score,
  directSpeed,
  reverseSpeed,
  timeString,
  forecastSlot,
}: SpeedStatProps & {
  forecastSlot: React.ReactNode;
}) {
  const {
    spacings: { sp, icons },
  } = useContext(UiContext);
  const theme = useTheme();

  return (
    <Paper
      elevation={DEFAULT_ELEVATION + 1}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        py: sp.s30,
        px: sp.s25,
        gap: sp.s25,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'stretch',
          gap: sp.s50,
        }}
      >
        {/* Значек с баллом */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '3px',
            bgcolor: getScoreThemeColor(score),
            borderRadius: '5px',
            width: icons['60x50'].w,
            height: 'auto',
          }}
        >
          <Typography
            sx={{ color: 'custom.scoreDigit', marginTop: '3px' }}
            variant="f26"
          >
            {score}
          </Typography>
          <IconCODD
            sizeKey="20x20"
            extColor={theme.palette.custom.scoreDigit}
          ></IconCODD>
        </Box>

        {/* Статистика */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: sp.s10,
          }}
        >
          <Typography sx={{ color: 'text.secondary' }} variant="f10">
            {timeString}
          </Typography>
          <Typography variant="f12">Скорость потока</Typography>
          <SpeedContainer
            directSpeed={directSpeed}
            reverseSpeed={reverseSpeed}
            isMobileIcons={true}
          ></SpeedContainer>
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: sp.s20,
        }}
      >
        <Typography sx={{ color: 'text.secondary' }} variant="f10">
          Прогноз
        </Typography>
        {forecastSlot}
      </Box>
    </Paper>
  );
}
